/**
 * Created by wingwan on 2018/4/17.
 */
import PicGenerator from "./PicGenerator.vue";
var PicGeneratorPlugin = {};

PicGeneratorPlugin.install = function (Vue) {
  PicGenerator.install(Vue);
  Vue.component('PicGenerator', PicGenerator);
};

export default PicGeneratorPlugin;